import { render } from "./AnswerList.vue?vue&type=template&id=87937cfe&scoped=true"
import script from "./AnswerList.vue?vue&type=script&lang=js"
export * from "./AnswerList.vue?vue&type=script&lang=js"

import "./AnswerList.vue?vue&type=style&index=0&id=87937cfe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87937cfe"]])

export default __exports__